/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Dual_Pass_LabelInputs */

const en_ocr_dual_pass_label = /** @type {(inputs: Ocr_Dual_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dual-pass (normal + inverted)`)
};

const fr_ocr_dual_pass_label = /** @type {(inputs: Ocr_Dual_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double passage (normal + inversé)`)
};

const de_ocr_dual_pass_label = /** @type {(inputs: Ocr_Dual_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelpass (normal + invertiert)`)
};

const it_ocr_dual_pass_label = /** @type {(inputs: Ocr_Dual_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppio passaggio (normale + invertito)`)
};

const ru_ocr_dual_pass_label = /** @type {(inputs: Ocr_Dual_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Двухпроходная обработка (обычная + инвертированная)`)
};

const es_ocr_dual_pass_label = /** @type {(inputs: Ocr_Dual_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doble paso (normal + invertido)`)
};

const zh_cn2_ocr_dual_pass_label = /** @type {(inputs: Ocr_Dual_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双通道（正向+反向）`)
};

const ja_ocr_dual_pass_label = /** @type {(inputs: Ocr_Dual_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デュアルパス（通常＋反転）`)
};

const hi_ocr_dual_pass_label = /** @type {(inputs: Ocr_Dual_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्यूल-पास (सामान्य + उलटा)`)
};

const pt_pt2_ocr_dual_pass_label = /** @type {(inputs: Ocr_Dual_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passagem dupla (normal + invertida)`)
};

/**
* | output |
* | --- |
* | "Dual-pass (normal + inverted)" |
*
* @param {Ocr_Dual_Pass_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_dual_pass_label = /** @type {((inputs?: Ocr_Dual_Pass_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Dual_Pass_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_dual_pass_label(inputs)
	if (locale === "de") return de_ocr_dual_pass_label(inputs)
	if (locale === "it") return it_ocr_dual_pass_label(inputs)
	if (locale === "ru") return ru_ocr_dual_pass_label(inputs)
	if (locale === "es") return es_ocr_dual_pass_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_dual_pass_label(inputs)
	if (locale === "ja") return ja_ocr_dual_pass_label(inputs)
	if (locale === "hi") return hi_ocr_dual_pass_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_dual_pass_label(inputs)
	return en_ocr_dual_pass_label(inputs)
});